import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hr-update',
  templateUrl: './hr-update.component.html',
  styleUrls: ['./hr-update.component.scss']
})
export class HRUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
